import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AgriculturePage = lazy(() => import('../pages/services/agriculture/page'));
const DeerSurveyPage = lazy(() => import('../pages/services/deer-survey/page'));
const DeerDeterrentPage = lazy(() => import('../pages/services/deer-deterrent/page'));
const TimberForestryPage = lazy(() => import('../pages/services/timber-forestry/page'));
const LandIntelligencePage = lazy(() => import('../pages/services/land-intelligence/page'));
const PortfolioMonitoringPage = lazy(() => import('../pages/services/portfolio-monitoring/page'));
const SurveysPage = lazy(() => import('../pages/services/surveys/page'));
const RecoveryPage = lazy(() => import('../pages/services/recovery/page'));
const InfrastructurePage = lazy(() => import('../pages/services/infrastructure/page'));
const IndustriesPage = lazy(() => import('../pages/industries/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const HowWeWorkPage = lazy(() => import('../pages/how-we-work/page'));
const SeasonalProgramsPage = lazy(() => import('../pages/seasonal-programs/page'));
const FinancingPage = lazy(() => import('../pages/financing/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));
const InstantQuotePage = lazy(() => import('../pages/instant-quote/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const BlogDroneMapsPage = lazy(() => import('../pages/blog/drone-maps-precision-agriculture/page'));
const ROICalculatorPage = lazy(() => import('../pages/roi-calculator/page'));
const OperatorChecklistPage = lazy(() => import('../pages/operator-checklist/page'));
const FieldComplexityPage = lazy(() => import('../pages/field-complexity/page'));
const CropCalendarPage = lazy(() => import('../pages/crop-calendar/page'));
const SprayWindowAdvisorPage = lazy(() => import('../pages/spray-window-advisor/page'));
const DroneSprayingProblemsPage = lazy(() => import('../pages/drone-spraying-problems/page'));
const DeerSurveyReportExamplePage = lazy(() => import('../pages/deer-survey-report-example/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const InfrastructurePricingPage = lazy(() => import('../pages/infrastructure-pricing/page'));
const LandIntelligencePricingPage = lazy(() => import('../pages/land-intelligence-pricing/page'));
const PortfolioMonitoringPricingPage = lazy(() => import('../pages/portfolio-monitoring-pricing/page'));
const TimberForestryPricingPage = lazy(() => import('../pages/timber-forestry-pricing/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/agriculture',
    element: <AgriculturePage />,
  },
  {
    path: '/services/deer-survey',
    element: <DeerSurveyPage />,
  },
  {
    path: '/services/deer-deterrent',
    element: <DeerDeterrentPage />,
  },
  {
    path: '/services/timber-forestry',
    element: <TimberForestryPage />,
  },
  {
    path: '/services/land-intelligence',
    element: <LandIntelligencePage />,
  },
  {
    path: '/services/portfolio-monitoring',
    element: <PortfolioMonitoringPage />,
  },
  {
    path: '/services/surveys',
    element: <SurveysPage />,
  },
  {
    path: '/services/recovery',
    element: <RecoveryPage />,
  },
  {
    path: '/services/infrastructure',
    element: <InfrastructurePage />,
  },
  {
    path: '/industries',
    element: <IndustriesPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/how-we-work',
    element: <HowWeWorkPage />,
  },
  {
    path: '/seasonal-programs',
    element: <SeasonalProgramsPage />,
  },
  {
    path: '/financing',
    element: <FinancingPage />,
  },
  {
    path: '/careers',
    element: <CareersPage />,
  },
  {
    path: '/instant-quote',
    element: <InstantQuotePage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/blog/drone-maps-precision-agriculture',
    element: <BlogDroneMapsPage />,
  },
  {
    path: '/roi-calculator',
    element: <ROICalculatorPage />,
  },
  {
    path: '/operator-checklist',
    element: <OperatorChecklistPage />,
  },
  {
    path: '/field-complexity',
    element: <FieldComplexityPage />,
  },
  {
    path: '/crop-calendar',
    element: <CropCalendarPage />,
  },
  {
    path: '/spray-window-advisor',
    element: <SprayWindowAdvisorPage />,
  },
  {
    path: '/drone-spraying-problems',
    element: <DroneSprayingProblemsPage />,
  },
  {
    path: '/deer-survey-report-example',
    element: <DeerSurveyReportExamplePage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/infrastructure-pricing',
    element: <InfrastructurePricingPage />,
  },
  {
    path: '/land-intelligence-pricing',
    element: <LandIntelligencePricingPage />,
  },
  {
    path: '/portfolio-monitoring-pricing',
    element: <PortfolioMonitoringPricingPage />,
  },
  {
    path: '/timber-forestry-pricing',
    element: <TimberForestryPricingPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
